export default __webpack_public_path__ + "static/media/browse-bg.04fb979e.png";